export default function JoinWFPSection() {
  return (
    <section id="join-wfp" className="py-20 bg-black relative overflow-hidden">
      <div className="container mx-auto px-20 relative z-10 max-w-7xl">
        <div className="text-center mb-20">
          <div className="mb-10 relative inline-block">
            <h2 className="font-blinker text-7xl md:text-8xl leading-[0.55] tracking-0 mb-0">
              <span className="text-[#ff3131] font-bold">W.F.P.</span>
            </h2>
            <div className="w-full h-[3px] bg-gradient-to-r from-[#ffde59] to-[#ff39e5] my-0"></div>
            <h3 className="font-blinker text-4xl md:text-5xl leading-[0.55] tracking-[0.05em] font-bold">
              <span className="text-white">ENTERTAINMENT</span>
            </h3>
            <p className="text-white text-md mt-0 tracking-[0.05em] font-normal">
              Better Games | Better Content
            </p>
          </div>

          <p className="text-xl md:text-2xl text-white font-bold mb-2 mt-0">
            Building viral games and the ecosystem around them.
          </p>
          <p className="text-white text-base max-w-4xl mx-auto leading-relaxed">
            We're an indie studio, a media engine, and a launch program under one flag. We design for traction, ship with speed, and turn smart marketing into player momentum. Team is forming now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-5">
  
  {/* MEDIA */}
  <div className="bg-black border-[3px] border-[#ff3131] rounded-2xl flex items-center justify-center py-3 px-4">
    <div className="text-center">
      <h3 className="font-blinker text-6xl font-extrabold text-white leading-[0.55]">
        W.F.P.
      </h3>
      <h4 className="font-blinker text-4xl font-extrabold text-white leading-none mt-2">
        MEDIA
      </h4>
    </div>
  </div>

  {/* STUDIO */}
  <div className="bg-black border-[3px] border-[#ffed00] rounded-2xl flex items-center justify-center py-3 px-4">
    <div className="text-center">
      <h3 className="font-blinker text-6xl font-extrabold text-white leading-[0.55]">
        W.F.P.
      </h3>
      <h4 className="font-blinker text-4xl font-extrabold text-white leading-none mt-2">
        STUDIO
      </h4>
    </div>
  </div>

  {/* LAUNCH */}
  <div className="bg-black border-[3px] border-[#a300c5] rounded-2xl flex items-center justify-center py-3 px-4">
    <div className="text-center">
      <h3 className="font-blinker text-6xl font-extrabold text-white leading-[0.55]">
        W.F.P.
      </h3>
      <h4 className="font-blinker text-4xl font-extrabold text-white leading-none mt-2">
        LAUNCH
      </h4>
    </div>
  </div>

</div>


        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="bg-gradient-to-br from-[#1a0000] to-black border-[3px] border-[#ff3131] rounded-3xl p-8">
            <p className="text-gray-400 text-sm lowercase tracking-wider mb-6">
              coming soon
            </p>
            <h5 className="text-2xl font-bold text-white mb-6 leading-tight">Signal in a crowded feed.</h5>
            <p className="text-gray-300 text-base leading-relaxed">
              Original shows, developer features, and data-driven breakdowns that spotlight what actually gets players to click, watch, and play. MEDIA fuels awareness for our titles and amplifies the best in the scene.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#1a1a00] to-black border-[3px] border-[#ffed00] rounded-3xl p-8">
            <p className="text-gray-400 text-sm lowercase tracking-wider mb-6">
              in development
            </p>
            <h5 className="text-2xl font-bold text-white mb-6 leading-tight">Small team. Fast cycles. Viral ideas.</h5>
            <p className="text-gray-300 text-base leading-relaxed">
              We prototype quickly, test in public, and double down on what hooks players. No red tape. High ownership. Your work ships and your work matters.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#0d0014] to-black border-[3px] border-[#a300c5] rounded-3xl p-8">
            <p className="text-gray-400 text-sm lowercase tracking-wider mb-6">
              open soon
            </p>
            <h5 className="text-2xl font-bold text-white mb-6 leading-tight">Your unfair advantage for traction.</h5>
            <p className="text-gray-300 text-base leading-relaxed">
              Training, playbook, and community designed to help indies build games people share. Learn the systems behind sticky hooks, clean positioning, and momentum you can repeat.
            </p>
          </div>
        </div>

        {/* Gradient stroke wrapper */}
<div className="rounded-3xl p-[3px] bg-[linear-gradient(to_right,#ffde59,#ff39e5)] mb-10">
  {/* Inner panel */}
  <div className="bg-black rounded-3xl p-5 text-center relative">
    <h3 className="font-blinker text-4xl md:text-8xl font-bold text-white mb-8 leading-tight">
      We're building the team
    </h3>

    <p className="text-white text-base max-w-3xl mx-auto mb-10 leading-relaxed">
     If you're a self-starter who learns fast and ships, we want to talk. Designers, engineers, producers, editors, marketers. Bring your craft. Bring your ambition.
    </p>
    <a
      href="https://apply.yokzona.com"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block bg-gradient-to-r from-[#ffde59] to-[#ff39e5] text-black px-12 py-5 font-blinker text-2xl font-bold hover:scale-105 transition-all duration-300 rounded-xl"
    >
      Apply to Join
    </a>
  </div>
</div>

        <div className="text-center">
          <div className="inline-block bg-black border-[3px] border-[#000000] px-6 py-3 rounded-lg">
            <p className="text-sm font-bold">
              <span className="text-[#ffed00]">Studio.</span>{' '}
              <span className="text-[#ff3131]">Media.</span>{' '}
              <span className="text-[#a300c5]">Launch.</span>{' '}
              <span className="text-white">All focused on traction.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
